<template>
  <div class="registerBox">
    <auth-logo />

    <van-tabs @click="onClick" v-model="active" class="loginTabs" animated>
      <van-tab :title="$t.auth.login"></van-tab>
      <van-tab :title="$t.auth.register"></van-tab>
    </van-tabs>

    <!-- 表单 -->
    <div class="formBox">
      <div class="selectBox">
        <div class="registerType" @click="showRegisterTypePicker = true">
          <span style="margin-right: 5px">{{ auth.registerTypeStr }}</span>
          <span><van-icon name="sort" /></span>
        </div>
      </div>
      <div class="inputBox" v-if="auth.registerType == 1">
        <input
          class="username"
          v-model="auth.phoneNumber"
          type="text"
          :placeholder="$t.auth.inputPhoneNumber"
        />
      </div>
      <div class="inputBox" v-if="auth.registerType == 2">
        <input
          class="username"
          v-model="auth.email"
          type="text"
          :placeholder="$t.auth.inputEmail"
        />
      </div>
      <div class="inputBox">
        <input
          class="password"
          v-model="auth.verificationCode"
          type="text"
          :placeholder="$t.auth.inputVcode"
        />
        <button class="getCode" v-if="isShowCode" @click="sendCode">
          {{ $t.auth.sendAuthCode }}
        </button>
        <div class="codeInfo" v-else>{{ timerNum }}S</div>
      </div>
      <div class="next" @click="next">{{ $t.auth.next }}</div>
      <div class="terms">
        <div class="termsCheckbox">
          <van-checkbox v-model="checked" checked-color="#00e0b6"></van-checkbox>
        </div>
        <div @click="gotoPrivacy" class="termsText">
          {{ $t.auth.rulesAndProtocols }}
        </div>
      </div>
      <div class="forget" @click="onforget">{{ $t.auth.forgetPassword }}?</div>
    </div>

    <van-popup v-model="showRegisterTypePicker" round position="bottom">
      <van-picker
        :title="$t.auth.pickerType2"
        show-toolbar
        :columns="registerTypeOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="registerTypeConfirm($event)"
        @cancel="showRegisterTypePicker = false"
      />
    </van-popup>

    <auth-background />
  </div>
</template>
<script>
import AuthLogo from "./components/AuthLogo";
import AuthBackground from "./components/AuthBackground";
import { Tab, Tabs, Checkbox, RadioGroup, Radio, Icon, Popup, Picker } from "vant";
import Vue from "vue";

Vue.use(Tab)
  .use(Tabs)
  .use(Checkbox)
  .use(RadioGroup)
  .use(Radio)
  .use(Icon)
  .use(Popup)
  .use(Picker);

export default {
  name: "register",
  components: {
    AuthLogo,
    AuthBackground,
  },
  data() {
    return {
      active: 1,
      radio: 1,
      isShowCode: true,
      timerNum: 0,
      timerItem: null,
      auth: {
        registerType: 1,
        registerTypeStr: this.$t.auth.phoneNumber,
        phoneNumber: "",
        email: "",
        password: "",
        verificationCode: "",
        companyCode: "",
      },
      checked: false,
      registerTypeOptions: [
        {
          text: this.$t.auth.phoneNumber,
          value: 1,
        },
        {
          text: this.$t.auth.email,
          value: 2,
        },
      ],
      showRegisterTypePicker: false,
    };
  },
  mounted() {
    const { CompanyCode } = this.$route.query;
    if (CompanyCode) {
      this.auth.companyCode = CompanyCode;
    }
  },
  methods: {
    registerTypeConfirm(e) {
      this.auth.registerTypeStr = e.text;
      this.auth.registerType = e.value;
      this.showRegisterTypePicker = false;
    },
    gotoPrivacy() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "privacy",
        name: "privacy",
        query: [],
      });
    },
    onforget() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "auth/resetPassword",
        name: "ResetPassword",
        query: [],
      });
    },
    next() {
      if (!this.checked) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: this.$t.auth.tick + this.$t.auth.rulesAndProtocols,
        });
        return false;
      }
      if (this.auth.phoneNumber == "" && this.auth.email == "") {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.auth.inputUsername,
          type: "danger",
        });
        return false;
      }
      if (this.auth.verificationCode == "") {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.auth.inputVcode,
          type: "danger",
        });
        return false;
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "auth/regInfo",
        name: "RegInfo",
        query: [
          {
            name: "RegisterType",
            value: this.auth.registerType,
          },
          {
            name: "PhoneNumber",
            value: this.auth.phoneNumber,
          },
          {
            name: "Email",
            value: this.auth.email,
          },
          {
            name: "VerificationCode",
            value: this.auth.verificationCode,
          },
          {
            name: "CompanyCode",
            value: this.auth.companyCode,
          },
        ],
      });
    },
    onClick(index) {
      if (index == 0) {
        if (this.auth.companyCode) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: true,
            path: "auth/login",
            name: "Login",
            query: [
              {
                name: "CompanyCode",
                value: this.auth.companyCode,
              },
            ],
          });
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: false,
            path: "auth/login",
            name: "Login",
            query: [],
          });
        }
      }
    },
    sendCode() {
      const checkPhone = /^1[3|4|5|8][0-9]\d{4,8}$/;
      const phone = this.auth.phoneNumber;
      const checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const email = this.auth.email;
      if (this.auth.registerType == 1) {
        if (checkPhone.test(phone)) {
          this.sendVerificationCode();
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCorrentPhoneNumber,
            type: "danger",
          });
        }
      }
      if (this.auth.registerType == 2) {
        if (checkEmail.test(email)) {
          this.sendVerificationCode();
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCorrentEmail,
            type: "danger",
          });
        }
      }
    },
    sendVerificationCode() {
      this.$commonMethod.showLoading();
      var param = {
        AccountType: this.auth.registerType,
        Phone: this.auth.phoneNumber,
        Email: this.auth.email,
      };
      this.$api.user
        .sendVerificationCode(param)
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.verificationCodeInfo,
            type: "success",
          });
          //启动定时器
          this.timerTime();
          this.$commonMethod.hideLoading();
        })
        .catch((err) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    //定时器
    timerTime() {
      this.timerNum = 120;
      this.isShowCode = false;
      this.timerItem = setInterval(() => {
        this.timerNum--;
        if (this.timerNum < 1) {
          clearInterval(this.timerItem);
          this.isShowCode = true;
        }
      }, 1000);
    },
  },
  destroyed() {
    clearInterval(this.timerItem);
    this.timerItem = null;
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.registerBox {
  position: relative;
  width: 100%;
  .loginTabs {
    ::v-deep .van-tabs__nav {
      background: rgba(0, 0, 0, 0.1);
    }
    ::v-deep .van-tabs__wrap {
      width: 60%;
      border-radius: 10rem;
      margin: auto;
      border: none !important;
    }
    ::v-deep .van-tab {
      color: #fff;
      font-weight: bold;
    }
    ::v-deep .van-tab--active {
      border-radius: 10rem;
      background: #fff;
      color: #304156;
    }
    ::v-deep .van-hairline--top-bottom::after {
      display: none;
    }
    ::v-deep .van-tabs__line {
      display: none;
    }
    ::v-deep .van-tab__text {
      font-size: 1rem;
      line-height: 2;
      overflow: visible;
    }
  }
  //表单
  .formBox {
    width: 85%;
    position: relative;
    margin: 0 auto;
    margin-top: 1.5rem;
    .formTitle {
      width: 190px;
      border-radius: 50px;
      background-color: #ffffff;
      color: #304156;
      height: 24px;
      font-size: 26px;
      text-align: center;
      height: 70px;
      line-height: 70px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
    }
    .selectBox {
      justify-content: space-between;
      align-items: center;
      width: 100%;
      @include publicFlex;
      .registerType {
        background: none;
        outline: none;
        border: none;
        -webkit-appearance: none; /*去除系统默认的样式*/
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
        color: #f3faf8;
        font-size: 0.8rem;
        width: 100%;
        height: 20px;
        line-height: 20px;
        padding: 0 1.5rem;
        box-sizing: border-box;
        text-align: right;
      }
    }
    .inputBox {
      justify-content: space-between;
      align-items: center;
      margin-top: 18px;
      width: 100%;
      @include publicFlex;
      .username,
      .password {
        background: none;
        outline: none;
        border: none;
        -webkit-appearance: none; /*去除系统默认的样式*/
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
        color: #f3faf8;
        font-size: 1rem;
        width: 100%;
        height: 50px;
        line-height: normal;
        border: 0.1rem solid #ffffff;
        border-radius: 100px;
        padding: 0 1.5rem;
        box-sizing: border-box;
        &::placeholder {
          color: #f3faf8;
          font-size: 1rem;
        }
        &::-webkit-input-placeholder {
          color: #f3faf8;
          font-size: 1rem;
        }
      }
      .getCode,
      .codeInfo {
        outline: none;
        border: 0;
        height: 50px;
        width: 185px;
        background-color: #ffffff;
        color: #304156;
        font-size: 0.8rem;
        text-align: center;
        border-radius: 80px;
        overflow: hidden;
        margin-left: 5%;
      }
      .codeInfo {
        font-size: 1rem;
        line-height: 50px;
        background-color: #dcdcdc;
        color: #ffffff;
      }
    }
    .next {
      width: 100%;
      border-radius: 50px;
      line-height: 50px;
      text-align: center;
      color: #304156;
      font-size: 1rem;
      font-weight: bold;
      background-color: #f3faf8;
      margin-top: 20px;
    }
    .InvitationCode {
      margin-top: 20px;
      font-size: 24px;
      width: 100%;
      height: 96px;
      line-height: 96px;
      border: 1px solid #b9e1da;
      border-radius: 100px;
      padding: 0 47px;
      box-sizing: border-box;
      color: #000000;
      color: rgba(0, 0, 0, 1);
      font-size: 30px;
      font-family: Helvetica;
      font-weight: 400;
      opacity: 0.3;
    }
    .terms {
      margin-top: 30px;
      font-size: 13px;
      color: #ffffff;
      .termsCheckbox {
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        width: 20%;
        .van-checkbox {
          display: inline-block;
          vertical-align: middle;
          ::v-deep .van-checkbox__icon {
            color: #fff;
            font-size: 18px !important;
          }
        }
      }
      .termsText {
        display: inline-block;
        text-align: left;
        vertical-align: middle;
        width: 80%;
      }
    }
    .forget {
      margin-top: 30px;
      color: #00e0b6;
      text-align: center;
      font-size: 12px;
    }
  }
}
</style>
